import { useCallback, useEffect, useState } from "react";
import { projectsApi } from "../api/projectsApi";

export function useProjectsData({ showToast }) {
  const [customers, setCustomers] = useState([]);
  const [projects,  setProjects]  = useState([]);
  const [users,     setUsers]     = useState([]);
  const [loading,   setLoading]   = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const [custs, projs] = await Promise.all([
        projectsApi.listCustomers(),
        projectsApi.listProjects(),
      ]);
      setCustomers(Array.isArray(custs) ? custs : []);
      setProjects(Array.isArray(projs)  ? projs  : []);
    } catch (err) {
      showToast?.(err.message || "Failed to load", "error");
    } finally {
      setLoading(false);
    }
  }, [showToast]);

  useEffect(() => { reload(); }, [reload]);

  useEffect(() => {
    projectsApi.listUsers()
      .then(data => setUsers(Array.isArray(data) ? data : []))
      .catch(() => {});
  }, []);

  return { customers, projects, users, loading, reload };
}
